<template>
  <span class="match-time seconds" v-if="timer" :idfosbtimer="timer.idfosbtimer && timer.idfosbtimer.toString()">
    {{ timerCurrentRealValue }}
    <!--<table>-->
      <!--<tr v-for="(value, key) in timer">-->
        <!--<td>{{ key }}</td>-->
        <!--<td>{{ value }}</td>-->
      <!--</tr>-->
      <!--<tr>-->
        <!--<td></td>-->
        <!--<td></td>-->
      <!--</tr>-->
      <!--<tr>-->
        <!--<td>tslastupdated</td>-->
        <!--<td>{{ new Date(timer.tslastupdated) }}</td>-->
      <!--</tr>-->
      <!--<tr>-->
        <!--<td>timerAgeInSeconds</td>-->
        <!--<td>{{ timerAgeInSeconds }}</td>-->
      <!--</tr>-->
      <!--<tr>-->
        <!--<td>timerRealValue</td>-->
        <!--<td>{{ timerRealValue }}</td>-->
      <!--</tr>-->
      <!--<tr>-->
        <!--<td>count</td>-->
        <!--<td>{{ count }}</td>-->
      <!--</tr>-->
      <!--<tr>-->
        <!--<td>localClockOffsetInSeconds</td>-->
        <!--<td>{{ localClockOffsetInSeconds }}</td>-->
      <!--</tr>-->
    <!--</table>-->
  </span>
</template>
<script>
  import store from '@/store'
//  import Vue from 'vue'

  export default {
    name: 'match-time-display-component',

    props: [
      'timer'
    ],

    data () {
      return {
        count: 0,
        displayFormat: 'mm', // mm - 3'   /  mm:ss - 3:33,
        showZeroTime: false
      }
    },

    computed: {
      localClockOffsetInSeconds () {
        return store.getters['livebettingState/localClockOffsetInSeconds']
      },
      timerAgeInSeconds () {
        if (this.timer && this.timer.isactive) {
          var counterTime = new Date(this.timer.tslastupdated)
          var currentTime = (new Date()).getTime() + this.localClockOffsetInSeconds * 1000
          return Math.floor((currentTime - counterTime.getTime()) / 1000)
        }

        return 0
      },
      timerRealValue () {
        if (this.timer) {
          if (this.timer.currentvalue < 0) {
            return 0
          } else {
            if (this.timer.iscountdown) {
              return this.timer.currentvalue - this.timerAgeInSeconds
            } else {
              return this.timer.currentvalue + this.timerAgeInSeconds
            }
          }
        }
      },
      timerCurrentRealValue () {
        if (this.timerRealValue) {
          let value
          if (this.timer.iscountdown) {
            value = this.timerRealValue - this.count
          } else {
            value = this.timerRealValue + this.count
          }

          if (value >= 0) {
            let minutes = this.displayFormat === 'mm:ss' ? Math.floor(value / 60) : Math.ceil(value / 60)
            let seconds = value - minutes * 60
            seconds = (seconds < 10 ? ('0' + seconds) : seconds)

            return this.displayFormat === 'mm:ss' ? `${minutes}:${seconds}` : `${minutes}'`
          } else {
            return this.showZeroTime ? (this.displayFormat === 'mm:ss' ? '0:00' : '0\'') : ''
          }
        } else {
          return this.showZeroTime ? (this.displayFormat === 'mm:ss' ? '0:00' : '0\'') : ''
        }
      }
    },

    methods: {

    },
    mounted () {
      setInterval(() => {
        if (this.timer && this.timer.isactive) {
          this.count++
        }
      }, 1000)
    },

    watch: {
      timerRealValue () {
        this.count = 0
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .match-time.seconds {
    width: 35px;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/bettingoffer/live/matchTimeDisplay.vue